import Dexie, { Table } from 'dexie';
import { SFConnection } from './sf-connector';
import { CQAppConstant } from 'app-constants';

interface IKVPStore {
    [key: string]: string
}

export interface KVP {
    id?:number
    key: string;
    value: string;
    orgId: string;
}

export class CQDB extends Dexie {
    kvps!: Table<KVP>;

    constructor() {
        super('cq-mgmt-db');
        this.version(1).stores({
            kvps: '++id, key, value, orgId',
        });
    }
}

const db = new CQDB();

/**
 * This is default storage that uses Salesforce org to store data
 * Storing original in SF is done in async manner and can fail
 */
export class Storage {

    kvpStore : IKVPStore = {};
    logId : string = '';
    folderId: string = '';

    readData(key: string) {
        return this.kvpStore[key];
    }
    /**
     * Restores i.e. reloads the past runs into memory from database (document in SF)
     */
    async restore() {
        try{
            //Restore from Database.
            let status = await SFConnection.getAxiosInstance().get(CQAppConstant.STATUS);
            let currentState = status.data;  
            if (currentState && Object.keys(currentState).length > 0) {
                this.kvpStore = currentState;
                return;
            }
            console.log("Database returned empty data");
        }
        catch(error){
            console.error("Error while restoring from database",error);
            return Promise.reject(error);
        }
    }
}

const DefaultStorage = new Storage();

export default DefaultStorage;